import { initSentry } from "./lib/sentry";
import { initAnalytics } from "./lib/analytics";
import { initMetaPixelConsent } from "./lib/meta-pixel";

initSentry();
initAnalytics();
initMetaPixelConsent();

import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
